(ns yardwerkz.api
  "Generated Capra API client stubs.
   Each function records an op and returns a PendingRef.
   Use with capra/ctx and capra/await."
  (:require-macros [capra.client :refer [gen-stubs]])
  (:require [capra.core :as capra]
            [yardwerkz.capra.api-spec :as api-spec]))

(gen-stubs yardwerkz.capra.api-spec/api-methods)
